import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs';
import {environment} from '../../../environments/environment';

declare global {
  interface Window {
    umami?: {
      track: (eventName?: string, eventData?: Record<string, unknown>) => void;
    };
  }
}

@Injectable({providedIn: 'root'})
export class AnalyticsService {
  private initialized = false;
  private readonly config = environment.analytics;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router
  ) {}

  init(): void {
    if (this.initialized || !this.canTrack()) {
      return;
    }

    this.initialized = true;
    this.loadScript();
    this.trackPageViews();
  }

  track(eventName: string, eventData?: Record<string, unknown>): void {
    if (!this.canTrack()) {
      return;
    }

    window.umami?.track(eventName, eventData);
  }

  private trackPageViews(): void {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => window.umami?.track());
  }

  private loadScript(): void {
    if (this.document.querySelector('script[data-umami-tracker="true"]')) {
      return;
    }

    const script = this.document.createElement('script');
    script.defer = true;
    script.src = this.config.scriptUrl;
    script.dataset['websiteId'] = this.config.websiteId;
    script.dataset['umamiTracker'] = 'true';
    this.document.head.appendChild(script);
  }

  private canTrack(): boolean {
    return !!(
      this.config?.enabled &&
      this.config.scriptUrl &&
      this.config.websiteId &&
      this.config.websiteId !== 'REPLACE_WITH_UMAMI_WEBSITE_ID'
    );
  }
}
